/**
 * Módulo F-22 AT 2026 - Régimen 14 D N°8 (Pro Pyme Transparente)
 * Las secciones y el cálculo son los comunes del régimen (../../14d8); aquí va lo propio
 * del año: su persistencia y el arrastre del AT 2025.
 */
import { getIDPCAT } from '../../../../../services/declaracionRenta/f22Service';
import { loadersComunes } from '../../14d8/modulo';

export * from '../../14d8/modulo';
export { createInitialState, rowToState, OUTPUT_CODES } from './persistence';
export { CODIGOS_PAGADO, CODIGOS_DESTACADOS } from './codigosPagado';

export const dataLoaders = [
  ...loadersComunes(2026),
  {
    key: 'idpcAt2025',
    // AT 2025: CPT inicial, IDPC y reajuste desde el F22 pagado cargado de ese año. Si el
    // AT 2025 fue 14 D N°8, el CPT inicial es su CPTS final (1581 o 1583); si fue 14 D N°3,
    // su CPTS final del recuadro 19 (1545). Sin certificado cargado, todo en 0 (a mano).
    loader: (idCompany) => getIDPCAT(idCompany, 2025),
    apply: (formData, result) => {
      if (!result?.data) return formData;
      return {
        ...formData,
        antecedentes: {
          ...formData.antecedentes,
          cptInicialPositivo: result.data.cptsPositivo1581 || result.data.cpts1545 || 0,
          cptInicialNegativo: result.data.cptsNegativo1583 || 0,
          pagoIDPCAnterior: result.data.idpcTotal || 0,
          pagoInteresesMultas: result.data.reajusteArt72 || 0,
        },
      };
    },
  },
];
